import { getAssetPath } from '../../../../lib/assetPath';
import { useTranslation } from '../../../../lib/i18n';

export type OtherProductCardProps = {
  name?: string;
  imagePath: string;
  watchTutorial?: boolean;
};

export const OtherProductCard = ({
  name,
  imagePath,
  watchTutorial = true,
}: OtherProductCardProps) => {
  return (
    <div className="flex p-4 flex-col items-start gap-5 rounded-lg bg-gradient-to-b from-[#FAF5F1] to-[#F5EEEB] justify-between">
      <h3 className="text-[#CE0A2C] font-minion text-[16px] font-normal w-[200px]">
        {name}
      </h3>
      <img
        src={getAssetPath(imagePath)}
        alt={imagePath}
        className="w-[200px] h-[200px] self-stretch aspect-square object-cover"
      />
      {/* {watchTutorial && <WatchTutorialButton />} */}
    </div>
  );
};

export const WatchTutorialButton = () => {
  const { t } = useTranslation();

  return (
    <div className="flex px-4 justify-center items-center gap-1 rounded-[70px] border border-[#3B3B3B66] bg-[#050505]">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.3335 3.82667C3.3335 3.17922 3.3335 2.8555 3.46849 2.67706C3.58609 2.5216 3.76584 2.4254 3.96043 2.41378C4.18379 2.40044 4.45314 2.58001 4.99184 2.93915L12.0022 7.61273C12.4473 7.90948 12.6699 8.05785 12.7475 8.24487C12.8153 8.40837 12.8153 8.59213 12.7475 8.75563C12.6699 8.94264 12.4473 9.09102 12.0022 9.38777L4.99184 14.0614C4.45314 14.4205 4.18379 14.6001 3.96043 14.5867C3.76584 14.5751 3.58609 14.4789 3.46849 14.3234C3.3335 14.145 3.3335 13.8213 3.3335 13.1738V3.82667Z"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <p className="flex w-[80px] h-[36px] flex-col justify-center text-white text-center font-minion text-[14px] font-normal leading-[150%] truncate">
        {t('watchTutorial')}
      </p>
    </div>
  );
};
